import Class from './c-config-pane';
import './c-config-pane@';
import './c-config-pane.scss';

export default Class;